(function ($) {
  customerServiceMobileV1 = {
    formatter: $('.cs-row-mobile-v1')
  };

  Drupal.behaviors.customerServiceMobileV1 = {
    get: function (key) {
      return customerServiceMobileV1[key];
    },

    set: function (key, val) {
      customerServiceMobileV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function (i) {
        var thisFormatter = $(this);
      // code goes here...
      });
    }
  };
})(jQuery);
